<template>
    <div class="staff">
        <el-form
            class="form-box"
            ref="addForm"
            :model="addForm"
            :rules="addFormRules"
            label-width="120px">
            <el-form-item label="弹窗名称：" prop="DialogName">
                <el-input
                    v-model="addForm.DialogName"
                    style="width:250px;">
                </el-input>
            </el-form-item>
            <el-form-item label="弹窗类型：" prop="DialogType">
                    <el-radio-group v-model="addForm.DialogType">
                    <el-radio :label="0">默认弹窗</el-radio>
                    <el-radio :label="1">活动弹窗</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="弹窗标题：" prop="DialogTitle">
                <el-input
                    v-model="addForm.DialogTitle"
                    style="width:250px;">
                </el-input>
            </el-form-item>
            <el-form-item label="弹窗正文：" prop="DialogContent">
                <div ref="editor" id="div1"></div>
            </el-form-item>
            <el-form-item label="主按钮文字：" prop="MainButtonWord">
                <el-input
                    v-model="addForm.MainButtonWord"
                    style="width:250px;">
                </el-input>
            </el-form-item>
            <el-form-item label="主按钮链接：" prop="MainButtonURL">
                <el-input
                    v-model="addForm.MainButtonURL"
                    style="width:250px;">
                </el-input>
            </el-form-item>
            <el-form-item v-if="addForm.DialogType==1" label="次按钮文字：" prop="SubButtonWord">
                <el-input
                    v-model="addForm.SubButtonWord"
                    style="width:250px;">
                </el-input>
            </el-form-item>
            <el-form-item v-if="addForm.DialogType==1" label="次按钮链接：" prop="SubButtonURL">
                <el-input
                    v-model="addForm.SubButtonURL"
                    style="width:250px;">
                </el-input>
            </el-form-item>
        </el-form>
        <div class="footer-box">
            <el-button @click="cancelFn">取消</el-button>
            <el-button type="primary" @click="previewFn">效果预览</el-button>
            <el-button type="primary" @click="saveFn">保存</el-button>
        </div>
        <!-- 效果预览弹窗 -->
        <el-dialog
            class="dialog-preview"
            title="效果预览"
            :visible.sync="dialogVisible"
            :before-close="handleClose">
            <div
                class="review-box"
                :class="{'review-box1':addForm.DialogType==1}">
                <div class="title">
                    {{addForm.DialogTitle}}
                    <i v-if="addForm.DialogType==1" class="icon-hot"></i>
                </div>
                <div class="content" v-html="addForm.DialogContent"></div>
                <div class="btn-box" v-if="addForm.DialogType==1">
                    <button class="btn">
                        {{addForm.SubButtonWord}}
                    </button>
                    <button class="btn btn2">
                        {{addForm.MainButtonWord}}
                    </button>
                </div>
                <div class="btn-box" v-else>
                    <button class="btn">
                        {{addForm.MainButtonWord}}
                    </button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import E from "wangeditor";
export default {
    data() {
        return {
            addForm:{
                DialogName:'',
                DialogType:0,
                DialogTitle:'',
                DialogContent:'',
                MainButtonWord:'',
                MainButtonURL:'',
                SubButtonWord:'',
                SubButtonURL:''
            },
            addFormRules:{
                DialogName:[
                    { required: true, message: '请输入弹窗名称', trigger: 'blur' },
                ],
                DialogType:[
                    { required: true, message: '请选择弹窗类型', trigger: 'change' }
                ],
                DialogTitle:[
                    { required: true, message: '请输入弹窗标题', trigger: 'blur' },
                    { max: 17, message: '长度小于17个字符', trigger: 'blur' }
                ],
                DialogContent:[
                    { required: true, message: '请输入弹窗内容'},
                ],
                MainButtonWord:[
                    { required: true, message: '请输入主按钮文字', trigger: 'blur' },
                    { max: 10, message: '长度小于10个字符', trigger: 'blur' }
                ],
                MainButtonURL:[
                    { required: true, message: '请输入主按钮链接', trigger: 'blur' },
                ],
                SubButtonWord:[
                    { required: true, message: '请输入次按钮文字', trigger: 'blur' },
                    { max: 10, message: '长度小于10个字符', trigger: 'blur' }
                ],
                SubButtonURL:[
                    { required: true, message: '请输入次按钮链接', trigger: 'blur' },
                ],
            },
            ed: "", // 富文本
            dialogVisible:false, // 是否显示弹窗
        }
    },
    created() {
        if(this.$route.query.Id) {
            this.addForm.Id = this.$route.query.Id;
            this.getDetail();
        }
    },
    mounted() {
        this.init_wangeditor();        
    },
    methods: {
        //富文本
        init_wangeditor() {
            let _this = this;
            const editor = new E("#div1");
            // this.editor = new E(this.$refs.editor);
            this.ed = editor;
            editor.config.zIndex = 1;
            editor.config.height = 350;
            editor.config.placeholder = "输入正文";
            editor.config.uploadImgAccept = ["jpg", "jpeg", "png", "svg"];
            editor.config.uploadImgMaxSize = 2 * 1024 * 1024; // 2M
            editor.config.uploadImgServer = "https://file.1renshi.com/FileHandler.ashx?module=article&type=image";
            editor.config.showLinkImg = false;
            editor.config.uploadFileName = "file[]";
            editor.config.uploadImgParams = {
                type: "image",
            };
            editor.config.uploadImgHooks = {
                customInsert: function (insertImg, result, editor2) {
                    uploadResult(result);
                    // var url = fileUrl + result.data.success[0].url;
                    insertImg(_this.uploadimg);
                },
            };
            function uploadResult(res) {
                if (res.isSucc) {
                    _this.uploadimg = res.success_list[0];
                }
            }
            editor.config.onchange = (html) => {
                _this.addForm.DialogContent = html;
            };
            editor.config.menus = [
                'fontSize', // 字号
                'foreColor', // 文字颜色
                'bold' // 加粗
            ];
            editor.create();
        },
        // 取消
        cancelFn() {
            this.$router.back();
        },
        // 预览
        previewFn() {
            this.dialogVisible=true;
        },
        // 关闭弹窗
        handleClose() {
            this.dialogVisible=false;
        },
        // 保存按钮
        saveFn() {
            this.$refs.addForm.validate((valid) => {
                if(!valid) return
                if(this.addForm.Id) {
                    this.editReq();
                } else {
                    this.addReq();
                }
            })
        },
        // 新增接口
        addReq() {
            this.$post(this.$api.AddAfterLoginDialog,{
                ...this.addForm,
            }).then(res=>{
                if(res.IsSuccess) {
                    this.cancelFn()
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        // 编辑接口
        editReq() {
            this.$post(this.$api.EditAfterLoginDialog,{
                ...this.addForm,
            }).then(res=>{
                if(res.IsSuccess) {
                    this.cancelFn()
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        // 获取详情
        getDetail() {
            this.$get(this.$api.GetDialogDeatail,{
                Id:this.addForm.Id,
            }).then(res=>{
                this.addForm=res.Data;
                if(this.ed) {
                    this.ed.txt.html(this.addForm.DialogContent);
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
.staff {
    background: #fff;
    padding: 10px 10px;
    min-height:100%;
    .form-box {
        padding-top:30px;
    }
    #div1 {
        width:700px;
    }
    .footer-box {
        text-align: center;
        .el-button+.el-button{
            margin-left: 100px;
        }
    }
    .dialog-preview {
        /deep/.el-dialog {
            width:fit-content;
        }
    }
    .review-box {
        padding: 24px 30px 30px;
        width: 454px;
        min-height: 213px;
        background: #FFFFFF;
        border-radius: 10px 10px 10px 10px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
        background-repeat: no-repeat;
        background-image:url("../../../assets/images/loginDialog/hd0.png");
        .title {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 20px;
            color: #3C3C3C;
            .icon-hot {
                display: inline-block;
                width:42px;
                height:20px;
                background-size:100%;
                background-repeat: no-repeat;
                background-image:url("../../../assets/images/loginDialog/hot.png");
                vertical-align: -2px;
            }
        }
        .content {
            margin-top:20px;
            margin-bottom:30px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 16px;
            color: #3C3C3C;
            line-height: 22px;
        }
        .btn-box {
            text-align: center;
            .btn {
                width: 184px;
                height: 40px;
                background: #4C80FA;
                border-radius: 6px 6px 6px 6px;
                border:1px solid transparent;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 38px;
                text-align: center;
            }
            .btn+.btn{
                margin-left: 20px;
            }
            .btn2 {
                background-color:#fff;
                border: 1px solid #4C80FA;
                color: #4C80FA;
            }
        }
    }
    .review-box1 {
        background-image:url("../../../assets/images/loginDialog/hd1.png");
    }
}
</style>